import { render, staticRenderFns } from "./btn-top-primary.vue?vue&type=template&id=d2095cf0&scoped=true&"
import script from "./btn-top-primary.vue?vue&type=script&lang=js&"
export * from "./btn-top-primary.vue?vue&type=script&lang=js&"
import style0 from "./btn-top-primary.vue?vue&type=style&index=0&id=d2095cf0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2095cf0",
  null
  
)

export default component.exports